import { render, staticRenderFns } from "./SolicitacoesPendentes.vue?vue&type=template&id=4ce7c414&scoped=true&"
import script from "./SolicitacoesPendentes.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesPendentes.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacoesPendentes.vue?vue&type=style&index=0&id=4ce7c414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7c414",
  null
  
)

export default component.exports